// // import React, { useState } from "react";
// // import {
// //   Box,
// //   Card,
// //   CardContent,
// //   Typography,
// //   TextField,
// //   Button,
// //   Alert,
// // } from "@mui/material";
// // import { useNavigate } from "react-router-dom";
// // import axiosInstance from "../../utils/axios";

// // export default function DeliveryLogin() {
// //   const [formData, setFormData] = useState({ emailOrPhone: "", password: "" });
// //   const [error, setError] = useState("");
// //   const [loading, setLoading] = useState(false);
// //   const navigate = useNavigate();

// //   const handleLogin = async (e) => {
// //     e.preventDefault();
// //     setError("");
// //     setLoading(true);
// //     try {
// //       const res = await axiosInstance.post("/api/delivery/login", formData);
// //       localStorage.setItem("deliveryUser", JSON.stringify(res.data.user));
// //       navigate("/delivery/dashboard");
// //     } catch (err) {
// //       setError(err.response?.data?.message || "Invalid credentials");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <Box
// //       minHeight="100vh"
// //       display="flex"
// //       justifyContent="center"
// //       alignItems="center"
// //       bgcolor="grey.100"
// //       p={2}
// //     >
// //       <Card sx={{ maxWidth: 400, width: "100%", p: 2 }}>
// //         <CardContent>
// //           <Typography variant="h5" align="center" fontWeight="bold" gutterBottom>
// //             Delivery Partner Login
// //           </Typography>
// //           <Typography variant="body2" color="text.secondary" align="center" mb={3}>
// //             Login to view assigned restaurants & orders
// //           </Typography>

// //           {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

// //           <form onSubmit={handleLogin}>
// //             <TextField
// //               fullWidth
// //               label="Email or Phone"
// //               margin="normal"
// //               required
// //               value={formData.emailOrPhone}
// //               onChange={(e) => setFormData({ ...formData, emailOrPhone: e.target.value })}
// //             />
// //             <TextField
// //               fullWidth
// //               label="Password"
// //               type="password"
// //               margin="normal"
// //               required
// //               value={formData.password}
// //               onChange={(e) => setFormData({ ...formData, password: e.target.value })}
// //             />
// //             <Button
// //               fullWidth
// //               type="submit"
// //               variant="contained"
// //               size="large"
// //               sx={{ mt: 3 }}
// //               disabled={loading}
// //             >
// //               {loading ? "Logging in..." : "Login"}
// //             </Button>
// //           </form>
// //         </CardContent>
// //       </Card>
// //     </Box>
// //   );
// // }

// import React, { useState } from "react";
// import {
//   Box,
//   Card,
//   Typography,
//   TextField,
//   Button,
//   Alert,
//   InputAdornment,
//   IconButton,
//   Avatar,
//   Divider,
//   CircularProgress,
//   Stack,
// } from "@mui/material";
// import {
//   Visibility,
//   VisibilityOff,
//   Email,
//   Lock,
//   LocalShipping,
//   ArrowForward,
//   Shield,
//   DeliveryDining,
// } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";
// import axiosInstance from "../../utils/axios";

// // 🎨 Brand Theme
// const BRAND = {
//   primary: "#FF6B00",
//   primaryDark: "#E85A00",
//   gradient: "linear-gradient(135deg, #FF6B00 0%, #E85A00 100%)",
//   gradientSoft: "linear-gradient(135deg, #FFF4EC 0%, #FFE8D6 100%)",
// };

// export default function DeliveryLogin() {
//   const [formData, setFormData] = useState({ emailOrPhone: "", password: "" });
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);
//     try {
//       const res = await axiosInstance.post("/api/delivery/login", formData);
//       localStorage.setItem("deliveryUser", JSON.stringify(res.data.user));
//       navigate("/delivery/dashboard");
//     } catch (err) {
//       setError(err.response?.data?.message || "Invalid credentials");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         position: "relative",
//         overflow: "hidden",
//         background: BRAND.gradient,
//         p: { xs: 2, sm: 3 },
//         // Decorative blobs
//         "&::before": {
//           content: '""',
//           position: "absolute",
//           top: "-120px",
//           left: "-120px",
//           width: 320,
//           height: 320,
//           borderRadius: "50%",
//           background: "rgba(255,255,255,0.08)",
//           pointerEvents: "none",
//         },
//         "&::after": {
//           content: '""',
//           position: "absolute",
//           bottom: "-140px",
//           right: "-100px",
//           width: 380,
//           height: 380,
//           borderRadius: "50%",
//           background: "rgba(255,255,255,0.06)",
//           pointerEvents: "none",
//         },
//       }}
//     >
//       {/* Main Card */}
//       <Card
//         elevation={0}
//         sx={{
//           position: "relative",
//           zIndex: 1,
//           maxWidth: 440,
//           width: "100%",
//           borderRadius: 4,
//           bgcolor: "#fff",
//           overflow: "visible",
//           boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
//           mt: { xs: 8, sm: 6 }, // space for floating avatar
//         }}
//       >
//         {/* Floating Brand Avatar */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: -44,
//             left: "50%",
//             transform: "translateX(-50%)",
//             width: 88,
//             height: 88,
//             borderRadius: "50%",
//             background: BRAND.gradient,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             boxShadow: "0 12px 28px rgba(255, 107, 0, 0.45)",
//             border: "4px solid #fff",
//           }}
//         >
//           <DeliveryDining sx={{ fontSize: 42, color: "#fff" }} />
//         </Box>

//         <Box sx={{ p: { xs: 3, sm: 4 }, pt: { xs: 7, sm: 7.5 } }}>
//           {/* Heading */}
//           <Typography
//             variant="h5"
//             align="center"
//             fontWeight={800}
//             sx={{ letterSpacing: -0.5, color: "#0f172a" }}
//           >
//             Delivery Partner Login
//           </Typography>
//           <Typography
//             variant="body2"
//             align="center"
//             sx={{ color: "#64748b", mt: 0.75, mb: 3, fontSize: 13 }}
//           >
//             Sign in to manage your assigned orders & deliveries
//           </Typography>

//           {/* Error Alert */}
//           {error && (
//             <Alert
//               severity="error"
//               sx={{
//                 mb: 2,
//                 borderRadius: 2,
//                 fontSize: 13,
//                 "& .MuiAlert-icon": { color: "#dc2626" },
//               }}
//             >
//               {error}
//             </Alert>
//           )}

//           {/* Form */}
//           <form onSubmit={handleLogin}>
//             <Stack spacing={2.2}>
//               {/* Email / Phone */}
//               <TextField
//                 fullWidth
//                 label="Email or Phone"
//                 placeholder="you@example.com or 9876543210"
//                 value={formData.emailOrPhone}
//                 onChange={(e) =>
//                   setFormData({ ...formData, emailOrPhone: e.target.value })
//                 }
//                 required
//                 size="medium"
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Email sx={{ color: BRAND.primary, fontSize: 20 }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={textFieldSx}
//               />

//               {/* Password */}
//               <TextField
//                 fullWidth
//                 label="Password"
//                 type={showPassword ? "text" : "password"}
//                 placeholder="Enter your password"
//                 value={formData.password}
//                 onChange={(e) =>
//                   setFormData({ ...formData, password: e.target.value })
//                 }
//                 required
//                 size="medium"
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Lock sx={{ color: BRAND.primary, fontSize: 20 }} />
//                     </InputAdornment>
//                   ),
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton
//                         aria-label={showPassword ? "Hide password" : "Show password"}
//                         onClick={() => setShowPassword((prev) => !prev)}
//                         onMouseDown={(e) => e.preventDefault()}
//                         edge="end"
//                         size="small"
//                         sx={{ color: "#94a3b8" }}
//                       >
//                         {showPassword ? (
//                           <VisibilityOff fontSize="small" />
//                         ) : (
//                           <Visibility fontSize="small" />
//                         )}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={textFieldSx}
//               />

//               {/* Login Button */}
//               <Button
//                 type="submit"
//                 fullWidth
//                 variant="contained"
//                 size="large"
//                 disabled={loading}
//                 endIcon={
//                   !loading && (
//                     <ArrowForward sx={{ transition: "transform 0.2s" }} />
//                   )
//                 }
//                 sx={{
//                   mt: 1,
//                   py: 1.4,
//                   borderRadius: 2.5,
//                   textTransform: "none",
//                   fontWeight: 700,
//                   fontSize: 15,
//                   background: BRAND.gradient,
//                   boxShadow: "0 8px 20px rgba(255, 107, 0, 0.35)",
//                   transition: "all 0.2s",
//                   "&:hover": {
//                     background: `linear-gradient(135deg, ${BRAND.primaryDark} 0%, ${BRAND.primary} 100%)`,
//                     boxShadow: "0 10px 26px rgba(255, 107, 0, 0.45)",
//                     transform: "translateY(-1px)",
//                     "& .MuiButton-endIcon svg": {
//                       transform: "translateX(3px)",
//                     },
//                   },
//                   "&:disabled": {
//                     background: "#e2e8f0",
//                     color: "#94a3b8",
//                     boxShadow: "none",
//                   },
//                 }}
//               >
//                 {loading ? (
//                   <Box display="flex" alignItems="center" gap={1}>
//                     <CircularProgress size={16} sx={{ color: "#fff" }} />
//                     Signing you in...
//                   </Box>
//                 ) : (
//                   "Login"
//                 )}
//               </Button>
//             </Stack>
//           </form>

//           {/* Divider */}
//           <Divider sx={{ my: 3, "&::before, &::after": { borderColor: "#f1f5f9" } }}>
//             <Typography
//               variant="caption"
//               sx={{ color: "#94a3b8", px: 1, fontSize: 11, fontWeight: 600 }}
//             >
//               SECURE LOGIN
//             </Typography>
//           </Divider>

//           {/* Footer Security Note */}
//           <Box
//             display="flex"
//             alignItems="center"
//             justifyContent="center"
//             gap={0.75}
//           >
//             <Shield sx={{ fontSize: 16, color: "#10b981" }} />
//             <Typography variant="caption" sx={{ color: "#64748b", fontSize: 11 }}>
//               Your credentials are encrypted & safe
//             </Typography>
//           </Box>
//         </Box>
//       </Card>

//       {/* Bottom brand tagline */}
//       <Typography
//         variant="caption"
//         sx={{
//           position: "absolute",
//           bottom: 16,
//           left: 0,
//           right: 0,
//           textAlign: "center",
//           color: "rgba(255,255,255,0.75)",
//           fontSize: 11,
//           fontWeight: 500,
//           zIndex: 1,
//         }}
//       >
//         © {new Date().getFullYear()} RestaurantWala. Delivery Partner Portal

//       </Typography>
//     </Box>
//   );
// }

// // 🎨 Reusable TextField styling
// const textFieldSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: 2.5,
//     backgroundColor: "#f8fafc",
//     transition: "all 0.2s",
//     "&:hover": {
//       backgroundColor: "#fff",
//     },
//     "& fieldset": {
//       borderColor: "#e2e8f0",
//     },
//     "&:hover fieldset": {
//       borderColor: "#cbd5e1",
//     },
//     "&.Mui-focused": {
//       backgroundColor: "#fff",
//       boxShadow: "0 0 0 3px rgba(255, 107, 0, 0.1)",
//     },
//     "&.Mui-focused fieldset": {
//       borderColor: BRAND.primary,
//       borderWidth: 1.5,
//     },
//   },
//   "& .MuiInputLabel-root.Mui-focused": {
//     color: BRAND.primaryDark,
//   },
//   "& .MuiInputLabel-root": {
//     fontSize: 14,
//   },
//   "& .MuiOutlinedInput-input": {
//     fontSize: 14,
//   },
// };

import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  TextField,
  Button,
  Alert,
  InputAdornment,
  IconButton,
  Divider,
  CircularProgress,
  Stack,
} from "@mui/material";
import {
  Visibility,
  VisibilityOff,
  Email,
  Lock,
  LocalShipping,
  ArrowForward,
  Shield,
  ArrowBack,
  Home,
} from "@mui/icons-material";
import { useNavigate, Link } from "react-router-dom";
import axiosInstance from "../../utils/axios";

// 🎨 Brand Theme
const BRAND = {
  primary: "#FF6B00",
  primaryDark: "#E85A00",
  gradient: "linear-gradient(135deg, #FF6B00 0%, #E85A00 100%)",
};

export default function DeliveryLogin() {
  const [formData, setFormData] = useState({ emailOrPhone: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axiosInstance.post("/api/delivery/login", formData);
      localStorage.setItem("deliveryUser", JSON.stringify(res.data.user));
      navigate("/delivery/dashboard");
    } catch (err) {
      setError(err.response?.data?.message || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
        background: BRAND.gradient,
        p: { xs: 2, sm: 3 },
        "&::before": {
          content: '""',
          position: "absolute",
          top: "-120px",
          left: "-120px",
          width: 320,
          height: 320,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.08)",
          pointerEvents: "none",
        },
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: "-140px",
          right: "-100px",
          width: 380,
          height: 380,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.06)",
          pointerEvents: "none",
        },
      }}
    >
      {/* ⬅️ Back to Home Button — Top Left */}
      <Box
        sx={{
          position: "absolute",
          top: { xs: 16, sm: 24 },
          left: { xs: 16, sm: 24 },
          zIndex: 10,
        }}
      >
        <Button
          component={Link}
          to="/"
          startIcon={<ArrowBack size={18} />}
          sx={{
            color: "#fff",
            backgroundColor: "rgba(255,255,255,0.15)",
            backdropFilter: "blur(10px)",
            borderRadius: "50px",
            px: 2.5,
            py: 1,
            textTransform: "none",
            fontWeight: 600,
            fontSize: { xs: "0.8rem", sm: "0.9rem" },
            border: "1px solid rgba(255,255,255,0.2)",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.25)",
              transform: "scale(1.05)",
            },
            transition: "all 0.3s ease",
          }}
        >
          <Home sx={{ mr: 0.5, fontSize: 20 }} />
          Back to Home
        </Button>
      </Box>

      {/* Main Card */}
      <Card
        elevation={0}
        sx={{
          position: "relative",
          zIndex: 1,
          maxWidth: 440,
          width: "100%",
          borderRadius: 4,
          bgcolor: "#fff",
          overflow: "visible",
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
          mt: { xs: 8, sm: 6 },
        }}
      >
        {/* Floating Brand Avatar */}
        <Box
          sx={{
            position: "absolute",
            top: -44,
            left: "50%",
            transform: "translateX(-50%)",
            width: 88,
            height: 88,
            borderRadius: "50%",
            background: BRAND.gradient,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 12px 28px rgba(255, 107, 0, 0.45)",
            border: "4px solid #fff",
          }}
        >
          <LocalShipping sx={{ fontSize: 42, color: "#fff" }} />
        </Box>

        <Box sx={{ p: { xs: 3, sm: 4 }, pt: { xs: 7, sm: 7.5 } }}>
          {/* Heading */}
          <Typography
            variant="h5"
            align="center"
            fontWeight={800}
            sx={{ letterSpacing: -0.5, color: "#0f172a" }}
          >
            Delivery Partner Login
          </Typography>
          <Typography
            variant="body2"
            align="center"
            sx={{ color: "#64748b", mt: 0.75, mb: 3, fontSize: 13 }}
          >
            Sign in to manage your assigned orders & deliveries
          </Typography>

          {/* Error Alert */}
          {error && (
            <Alert
              severity="error"
              sx={{
                mb: 2,
                borderRadius: 2,
                fontSize: 13,
                "& .MuiAlert-icon": { color: "#dc2626" },
              }}
            >
              {error}
            </Alert>
          )}

          {/* Form */}
          <form onSubmit={handleLogin}>
            <Stack spacing={2.2}>
              <TextField
                fullWidth
                label="Email or Phone"
                placeholder="you@example.com or 9876543210"
                value={formData.emailOrPhone}
                onChange={(e) =>
                  setFormData({ ...formData, emailOrPhone: e.target.value })
                }
                required
                size="medium"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Email sx={{ color: BRAND.primary, fontSize: 20 }} />
                    </InputAdornment>
                  ),
                }}
                sx={textFieldSx}
              />

              <TextField
                fullWidth
                label="Password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={formData.password}
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
                required
                size="medium"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock sx={{ color: BRAND.primary, fontSize: 20 }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label={
                          showPassword ? "Hide password" : "Show password"
                        }
                        onClick={() => setShowPassword((prev) => !prev)}
                        onMouseDown={(e) => e.preventDefault()}
                        edge="end"
                        size="small"
                        sx={{ color: "#94a3b8" }}
                      >
                        {showPassword ? (
                          <VisibilityOff fontSize="small" />
                        ) : (
                          <Visibility fontSize="small" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={textFieldSx}
              />

              {/* Forgot Password */}
              <Box sx={{ textAlign: "right", mb: 3 }}>
                <Typography
                  variant="caption"
                  component={Link}
                  to="/delivery/forgot-password"
                  sx={{
                    color: "var(--primary)",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontSize: "0.85rem",
                    textDecoration: "none",
                    "&:hover": {
                      textDecoration: "underline",
                      color: "var(--primary-dark)",
                    },
                  }}
                >
                  Forgot password?
                </Typography>
              </Box>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                disabled={loading}
                endIcon={
                  !loading && (
                    <ArrowForward sx={{ transition: "transform 0.2s" }} />
                  )
                }
                sx={{
                  mt: 1,
                  py: 1.4,
                  borderRadius: 2.5,
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: 15,
                  background: BRAND.gradient,
                  boxShadow: "0 8px 20px rgba(255, 107, 0, 0.35)",
                  transition: "all 0.2s",
                  "&:hover": {
                    background: `linear-gradient(135deg, ${BRAND.primaryDark} 0%, ${BRAND.primary} 100%)`,
                    boxShadow: "0 10px 26px rgba(255, 107, 0, 0.45)",
                    transform: "translateY(-1px)",
                    "& .MuiButton-endIcon svg": {
                      transform: "translateX(3px)",
                    },
                  },
                  "&:disabled": {
                    background: "#e2e8f0",
                    color: "#94a3b8",
                    boxShadow: "none",
                  },
                }}
              >
                {loading ? (
                  <Box display="flex" alignItems="center" gap={1}>
                    <CircularProgress size={16} sx={{ color: "#fff" }} />
                    Signing you in...
                  </Box>
                ) : (
                  "Login"
                )}
              </Button>
            </Stack>
          </form>

          <Divider
            sx={{ my: 3, "&::before, &::after": { borderColor: "#f1f5f9" } }}
          >
            <Typography
              variant="caption"
              sx={{ color: "#94a3b8", px: 1, fontSize: 11, fontWeight: 600 }}
            >
              SECURE LOGIN
            </Typography>
          </Divider>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={0.75}
          >
            <Shield sx={{ fontSize: 16, color: "#10b981" }} />
            <Typography
              variant="caption"
              sx={{ color: "#64748b", fontSize: 11 }}
            >
              Your credentials are encrypted & safe
            </Typography>
          </Box>
        </Box>
      </Card>

      {/* Bottom brand tagline */}
      <Typography
        variant="caption"
        sx={{
          position: "absolute",
          bottom: 16,
          left: 0,
          right: 0,
          textAlign: "center",
          color: "rgba(255,255,255,0.75)",
          fontSize: 11,
          fontWeight: 500,
          zIndex: 1,
        }}
      >
        © {new Date().getFullYear()} RestaurantWala • Your Digital Restaurant
        Partner
      </Typography>
    </Box>
  );
}

const textFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 2.5,
    backgroundColor: "#f8fafc",
    transition: "all 0.2s",
    "&:hover": { backgroundColor: "#fff" },
    "& fieldset": { borderColor: "#e2e8f0" },
    "&:hover fieldset": { borderColor: "#cbd5e1" },
    "&.Mui-focused": {
      backgroundColor: "#fff",
      boxShadow: "0 0 0 3px rgba(255, 107, 0, 0.1)",
    },
    "&.Mui-focused fieldset": {
      borderColor: BRAND.primary,
      borderWidth: 1.5,
    },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: BRAND.primaryDark },
  "& .MuiInputLabel-root": { fontSize: 14 },
  "& .MuiOutlinedInput-input": { fontSize: 14 },
};
